import { React, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import PubSub from "pubsub-js"

import IconArrow from "../../img/icon_arrow_left.svg"

function handleActive(event) {
    const sideChapter = document.getElementById("classroom_chapter");
    if (sideChapter.classList.value.includes("active"))
        sideChapter.classList.remove('active');
    else
        sideChapter.classList.toggle('active');
}

function openSideChapter() {
    const sideChapter = document.getElementById("classroom_chapter");
    sideChapter.classList.add('active');
}

function ClassroomChapter({ chapter, lessonId, onSelectLesson }) {
    const [currentLessonId, setCurrentLessonId] = useState(lessonId);

    const isReleased = (releaseDate) => {
        if (!releaseDate) return true; // If no release date, assume it's released
        const today = new Date();
        const release = new Date(releaseDate);
        return release <= today;
    };

    const formatReleaseDate = (releaseDate) => {
        if (!releaseDate) return '';
        const date = new Date(releaseDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `即將發布: ${year}/${month}/${day}`;
    };

    const handleSelectLesson = async (lessonId, releaseDate) => {
        if (!isReleased(releaseDate)) return; // Prevent clicking unreleased lessons
        setCurrentLessonId(lessonId);
        await onSelectLesson(lessonId);
    }

    useEffect(() => {
        setCurrentLessonId(lessonId);
        // scroll to active lesson
        const activeLesson = document.querySelector('.classroom_chapter_item .active');
        if (activeLesson) {
            activeLesson.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        openSideChapter();
    }, [lessonId])

    return (
        <div id="classroom_chapter" className='classroom_chapter'>
            <div className="classroom_chapter_btn" onClick={handleActive}>
                <img src={IconArrow} alt="" />
                <p>課<br></br>程<br></br>章<br></br>節</p>
            </div>
            <div className="classroom_chapter_content">
                {
                    chapter.map((data, index) => (
                        <div className="classroom_chapter_item" key={index + 1}>
                            <h2>{data.title}</h2>
                            <ul>
                                {
                                    data?.lessons?.map((lesson, index) => {
                                        const released = isReleased(lesson.releaseDate);
                                        const releaseInfo = !released ? formatReleaseDate(lesson.releaseDate) : '';
                                        return (
                                            <li key={`lesson-${index + 1}`}>
                                                <Link 
                                                    className={`${lesson.id === currentLessonId ? "active" : ""} ${!released ? "unreleased" : ""}`}
                                                    onClick={() => handleSelectLesson(lesson.id, lesson.releaseDate)}
                                                    title={releaseInfo}
                                                    style={!released ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
                                                >
                                                    <span className="classroom_chapter_name">{lesson.section}：{lesson.name}</span>
                                                    <span className="classroom_chapter_time">{lesson.contentLength}</span>
                                                </Link>
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ClassroomChapter;